<template>
  <div class="person-box">
      <!-- <p style="color:red">请提前准备好2寸证件照（400-600KB的JPG或PNG图片，用于会员证使用），再进行注册</p> -->
      <!-- <van-steps active-color="#228ccd" :active="active">
        <van-step>账号信息</van-step>
        <van-step>基本信息</van-step>
        <van-step>注册完成</van-step>
      </van-steps> -->
    <div class="content">
      <step-account @sendActive="setActive" @updateInfo="updateMember" @loginInfo="loginInfo" v-if="active === 0"></step-account>
      <!-- <step-base @sendActive="setActive" v-else-if="active === 1" :member="member"></step-base>
      <step-successed v-else></step-successed> -->
    </div>
    <p style="margin-top:10px">注册缴费成功后成为本会正式会员，可享受本会提供的各种增值服务，详见入会须知</p>
  </div>
</template>

<script>
import { getUser } from "@/api/dictionary";
import { Step, Steps,Checkbox} from "vant";
import stepAccount from "./account";
import stepBase from "./base";
import stepSuccessed from "./successed";
import {mapMutations,mapState,mapActions} from "vuex";

export default {
  data() {
    return {
      active: 0,
      member: {},
    };
  },
  components: {
    [Step.name]: Step,
    [Steps.name]: Steps,
    stepAccount,
    stepBase,
    stepSuccessed,
  },
  computed:{
    ...mapState(["userInfo"]),
  },
  methods: {
    ...mapActions(["securityCheck"]),
    ...mapMutations(["setMemberInfo"]),
    rule() {
      this.$router.push({ name: "rule" });
    },
    setActive(value) {
      this.active = value;
    },
    updateMember(value) {
      this.setMemberInfo(value);
      this.member = value;
    },
    loginInfo(value){
      this.login = value.login;
      this.password = value.password;
      this.submit();
    },
    submit() {
      var params = {
        username: this.login,
        password: this.password,
        memberCategory: 1,
        grant_type: "password",
        scope: "server",
        client_id: "mms_meeting",
        client_secret: 123456
      };
      this.securityCheck(params).then(res => {
        this.getUserInfo().then(res => {
          this.$router.push({ name: "MemberCenter"});
        })
        .catch(() => {
           Toast.fail("用户信息获取失败");
        });
      })
      .catch(res => {
         Toast.fail("登录失败");
      });
    },
    getUserInfo() {
      return new Promise(resolve => {
        getUser().then(res => {
          if (res.success) {
            this.setMemberInfo(res.result);
            sessionStorage.setItem("memberId", res.result.id);
            resolve();
          } else {
             Toast.fail("登录失败!");
          }
        })
        .catch(() => {
           Toast.fail("获取用户数据失败!");
        });
      });
    },
  },
  mounted(){
      let a = this.$route.query && this.$route.query.source;
      if(a==1){
        this.active = 1
        this.member = this.userInfo;
      }
  }
};
</script>

<style lang="less" scoped>
.person-box{
  p{font-size:13px; color:#999; line-height: 20px;}
  h3 {
    font-size: 18px;
    font-weight: normal;
    text-align: left;
    color: #000;
  }
}
</style>